import { Box, Center, Heading, Text } from '@chakra-ui/react'
import { ApiErrorKind } from '../../services/apiErrors'

const messages: Record<string, { heading: string; body: string }> = {
  [ApiErrorKind.Forbidden]: {
    heading: 'You do not have access to this report',
    body: 'It belongs to a plan your account is not set up for. If that looks wrong, contact your CEM representative.',
  },
  [ApiErrorKind.Unauthenticated]: {
    heading: 'Your session has ended',
    body: 'Reload the page to sign in again.',
  },
  [ApiErrorKind.Unknown]: {
    heading: 'We could not load this report',
    body: 'Something went wrong on our side. Please try again in a few moments.',
  },
}

/**
 * The report page's third state. Without it a denial is indistinguishable from a slow load: the
 * section list spins until the reader gives up.
 *
 * `kind` is typed loosely because it arrives from the MobX report store, which is plain JS.
 */
const ReportUnavailable = ({ kind }: { kind: string }) => {
  const { heading, body } = messages[kind] ?? messages[ApiErrorKind.Unknown]

  return (
    <Center
      width="100%"
      height="70vh">
      <Box
        maxW="30rem"
        textAlign="center">
        <Heading
          as="h2"
          size="md"
          mb={3}
          color="brand.textDarkBlue">
          {heading}
        </Heading>
        <Text color="brand.textBlue">{body}</Text>
      </Box>
    </Center>
  )
}

export default ReportUnavailable
